import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ErrorRed: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--ErrorRed')}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#AB2434" fillRule="nonzero">
        <g>
          <path d="M12,3.5 C16.6944204,3.5 20.5,7.30557963 20.5,12 C20.5,16.6944204 16.6944204,20.5 12,20.5 C7.30557963,20.5 3.5,16.6944204 3.5,12 C3.5,7.30557963 7.30557963,3.5 12,3.5 Z M9.19818454,8 L8,9.19818454 L10.802,12 L8,14.8018155 L9.19818454,16 L12,13.198 L14.8018155,16 L16,14.8018155 L13.198,12 L16,9.19818454 L14.8018155,8 L12,10.802 L9.19818454,8 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default ErrorRed;
